import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.67.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@swc+helpers@0.5.23_@types+react@19.3.0_next@16.4.5_@babel+core@7.29.7_acb4625394aa3638cacfe6c4008e1f28/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.5_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomeContactForm"] */ "/app/src/app/[locale]/(main)/_components/home/home-contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFeaturedDeferred"] */ "/app/src/app/[locale]/(main)/_components/home/home-featured-deferred.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkWithChannel"] */ "/app/src/ui/atoms/link-with-channel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignBoundary"] */ "/app/src/ui/components/black-friday/campaign-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RetailReferralLink"] */ "/app/src/ui/components/commerce/retail-referral-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlueprintFeatureCards"] */ "/app/src/ui/components/marketing/blueprint-feature-cards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CyclingAminoStrip"] */ "/app/src/ui/components/marketing/cycling-amino-strip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewportDeferredDecorativeVideo"] */ "/app/src/ui/components/marketing/deferred-decorative-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroCycler"] */ "/app/src/ui/components/marketing/hero-cycler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroReportCard"] */ "/app/src/ui/components/marketing/hero-report-card.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/marketing/scroll-reveal.tsx");
